export default {
    "cookies": {
        "title": "Uso de cookies",
        "description": "Utilizamos cookies, incluidas cookies de terceros, para recopilar información sobre cómo utilizan los visitantes nuestros sitios web. Nos ayudan a que pueda tener la mejor experiencia posible, mejorar continuamente nuestros sitios y ofrecerle información comercial que se adapte a sus intereses. Al hacer clic en el botón 'Aceptar todas', acepta el uso de estas cookies. Puede retirar su consentimiento en cualquier momento, cambiar sus preferencias y obtener información detallada sobre nuestro uso de",
        "link": "cookies consultando nuestra Política de cookies",
        "btnConfig": "Configurar cookies",
        "btnAccept": "Aceptar todas"
    },
    crossword: {
        misteriousCharacter: "personaje misterioso",
        horizontal: "Horizontales",
        vertical: "Verticales",
        empty: "Completa el crucigrama para poder participar",
        formTitle: "Completa el crucigrama, suscríbete al blog de MyInvestor y envía el formulario para participar en el sorteo",
        successMessage: {
            title: "Tu formulario se ha enviado correctamente",
            message: "¡Mucha suerte y gracias por participar!"
        }
    }
}
